var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_fc_fetch" },
    [
      _c("form-create", {
        attrs: { value: _vm.formValue, rule: _vm.rule, option: _vm.option },
        on: { change: _vm.input },
        model: {
          value: _vm.api,
          callback: function ($$v) {
            _vm.api = $$v
          },
          expression: "api",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }